import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import withLayout from "./_hocs/withLayout";

import NoMatch from "./views/NoMatch";
import TicketBase from "./views/Ticket/containers/TicketBase";
import TicketSearch from "./views/TicketSearch/containers/TicketSearchPage";

import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/it";
import "moment/locale/de";
import "moment/locale/nl";
import "moment/locale/cs";
import "moment/locale/pl";
import "moment/locale/ro";
import "moment/locale/se";

export default class App extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path="/404" component={NoMatch} />

                <Route exact path="/">
                    <Redirect to="/tickets/search" />
                </Route>
                <Route exact path="/tickets" component={withLayout(TicketBase, NoMatch)} />
                <Route exact path="/tickets/search" component={withLayout(TicketSearch, NoMatch)} />

                <Redirect to="/404" />
            </Switch>
        );
    }
}
